import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { Manifesto } from "@/components/site/Manifesto";
import { Services } from "@/components/site/Services";
import { ClientGrid } from "@/components/site/ClientGrid";
import { Thermal } from "@/components/site/Thermal";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";

export default function Home() {
  return (
    <div className="bg-background min-h-screen">
      <Header />
      <main>
        <Hero />
        <Manifesto />
        <Services />
        <ClientGrid />
        <Thermal />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
